import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import ChartAxisField_inThemes, { IChartAxisFieldOptions_inThemes } from './ChartAxisField_inThemes';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { ChartPropsManager } from '../ChartPropsManager';
import { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

//LL: With standard inheritance, on upper levels. See ChartAxisField_inThemes

function isOwnKey(ownKeys, propName) {
    let ii = _.indexOf(ownKeys, propName);
    return ii >= 0;
}

class ChartAxisArrayFieldRow extends React.Component<
    {
        value?;
        values?;
        i?: number;
        parentObj?;
        fictiv?: boolean;
        canRemove?: boolean;
        ownKey?: boolean;
        forActualChart?: boolean;
        isInherited?: boolean;
        useInheritedButton?: boolean;
        themeFields_forDefaultColors?;
        getDataType_Func?(values, glob: IGlob): { type?: string; timePart? };
        isAssignedSecondaryAxis_Func?;
        is_fullStackedOnAxis_Func?;
        canAxisLabelPrecision_byLabelFormat_Func?;
        getModifiedValuesAndDisplay_Full_Func?(values, glob: IGlob, axisName: string): { values; display };
        hasAxis_Bubble_Func?;
        themeFieldForAxisList;
        themeObj: appTheme.IValuesCollection;
        options: { widgetValues?; widgetTypeName?: string };
        glob: IGlob;

        onAddRow?(value): void;
        onChange?(value, index: number): void;
        onRemove?(name): void;
        onAddPredefinedAxis?(selectedPredefinedAxis): void;
    },
    {
        selectedPredefinedAxis;
    }
> {
    //LL: props of ChartAxisArrayFieldRow when standard inheritance
    //  ownKey, parentObj
    //  ownObj is just obj: value={obj}
    //  forActualChart, if false => values={props_values} is null
    //  isInherited  ( == !ownKey)
    //  useInheritedButton:  use arrow-down

    // private references: {
    //     selectAxis?: HTMLElement; // HTMLDivElement;
    // } = {};

    constructor(props) {
        super(props);

        this.state = {
            selectedPredefinedAxis: null //LL: for fictiv row
        };
    }

    isFictiv() {
        return this.props.fictiv === true;
    }

    handleValueChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i); // this.props.i ???
        }
    };

    getRemoveButton(value) {
        if (this.isFictiv()) {
            return;
        }

        if (value == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getBlock() {
        let obj = this.props.value || {};

        const options: IChartAxisFieldOptions_inThemes = {
            name: obj.name,
            kind: 'a',
            themeFields_forDefaultColors: this.props.themeFields_forDefaultColors,
            //prohibitInitialSet: true,
            onRemove: this.props.onRemove,
            canRemove: this.props.canRemove,
            getDataType_Func: this.props.getDataType_Func,
            isAssignedSecondaryAxis_Func: this.props.isAssignedSecondaryAxis_Func,
            is_fullStackedOnAxis_Func: this.props.is_fullStackedOnAxis_Func,
            //getFormatFrontArray_Numeric_Func: this.props.getFormatFrontArray_Numeric_Func,
            //getFormatFrontArray_DateTime_Func: this.props.getFormatFrontArray_DateTime_Func,
            //getFormatFrontArray_Date_Func: this.props.getFormatFrontArray_Date_Func,
            //getFormatFrontArray_Time_Func: this.props.getFormatFrontArray_Time_Func,
            //getFormatFrontArray_TimePart_Func: this.props.getFormatFrontArray_TimePart_Func,
            //getFormatFrontArray_TimeIntervals_Int_Func: this.props.getFormatFrontArray_TimeIntervals_Int_Func,
            //getFormatFrontArray_TimeIntervals_Real_Func: this.props.getFormatFrontArray_TimeIntervals_Real_Func,
            canAxisLabelPrecision_byLabelFormat_Func: this.props.canAxisLabelPrecision_byLabelFormat_Func,
            getModifiedValuesAndDisplay_Full_Func: this.props.getModifiedValuesAndDisplay_Full_Func,
            hasAxis_Bubble_Func: this.props.hasAxis_Bubble_Func
        };

        if (this.props.options != null) {
            options.widgetValues = this.props.options.widgetValues;
            options.widgetTypeName = this.props.options.widgetTypeName;
        }

        //LL: props of ChartAxisArrayFieldRow, when standard inheritance
        //  ownKey, parentObj
        //  ownObj is just obj: value={obj}
        //  forActualChart, if false => values={props_values} is null
        //  isInherited  ( == !ownKey)
        //  useInheritedButton:  use arrow-down
        //     ownKey={ ownKey }
        //     parentObj={ parentObj }
        //     forActualChart={ forActualChart }
        //     isInherited={ isInherited }
        //     useInheritedButton={ useInheritedButton }

        // //LL: see appTheme.getThemeOwnAndParentValues_forObjects:  props.options.optionThemeOwnAndParent
        // options.optionThemeOwnAndParent = {
        //     ownValue: this.props.value,
        //     parentValue: this.props.parentObj
        // };

        // options.forActualChart = this.props.forActualChart;
        // options.isInherited = this.props.isInherited;
        options.useInheritedButton = this.props.useInheritedButton;

        return (
            <div style={{ marginBottom: 6 }}>
                <ChartAxisField_inThemes
                    value={obj}
                    //values={this.props.values}
                    themeObj={this.props.themeObj}
                    options={options}
                    glob={this.props.glob}
                    onChange={this.handleValueChange}
                />
            </div>
        );
    }

    handleOnAddAxisButtonClick = (e) => {
        if (typeof this.props.onAddRow === 'function') {
            this.props.onAddRow({});
        }
    };

    processAddPredefinedAxis = (e) => {
        e.stopPropagation();
        e.preventDefault();

        //LL:   may be ''
        let selectedPredefinedAxis = this.state.selectedPredefinedAxis;

        if (typeof this.props.onAddPredefinedAxis === 'function') {
            this.props.onAddPredefinedAxis(selectedPredefinedAxis);
        }
    };

    // processAxisChange = (e) => {
    //     var val = (this.references.selectAxis as HTMLInputElement).value;

    //     this.setState(
    //         _.extend(this.state, {
    //             selectedPredefinedAxis: val
    //         })
    //     );
    // };

    getAddFresh() {
        return (
            <div className="entity-select add-axis">
                <div className="content add-button">
                    <span className="value">
                        <em className="empty btn btn-default" onClick={this.handleOnAddAxisButtonClick}>
                            {'Add Axis'}
                        </em>
                    </span>
                </div>
            </div>
        );
    }

    render() {
        if (this.isFictiv()) {
            let a = this.getAddFresh();

            return (
                <table>
                    <tbody>
                        <tr className="attribute-row">
                            <td className="cell-remove"></td>
                            <td colSpan={1}>{a}</td>
                        </tr>
                    </tbody>
                </table>
            );
        }

        const block = this.getBlock();

        return (
            <table style={{ width: '100%' }}>
                <tbody>
                    <tr className="attribute-row">
                        <td colSpan={2}>{block}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export interface IChartAxisArrayFieldOptions extends IParameterFieldBaseOptions {
    widgetTypeName?: string;
    widgetValues?;
    themeFieldForAxisList;
    themeFields_forDefaultColors;
}

export default class ChartAxisArrayField extends React.Component<
    {
        value;
        options: IChartAxisArrayFieldOptions;
        themeObj: appTheme.IValuesCollection;
        glob: IGlob;

        onChange(value): void;
    },
    {
        counter: number;
        forActualChart: boolean;
    }
> {
    public static numberOfEditedItems(ownValues, parentValues) {
        if (ownValues == null) {
            return 0;
        }

        //LL:  see ownKeys in render
        //  keys:  "AUX_1", "AUX_2",
        let keysArr = _.keys(ownValues); // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]

        if (parentValues == null) {
            let editedItemsSum = 0;

            _.each(keysArr, (obj) => {
                let editedItemsInAxis = ChartAxisField_inThemes.numberOfEditedItems(ownValues[obj], null);
                editedItemsSum += editedItemsInAxis;
            });
            return keysArr.length + editedItemsSum; // ???
        } else {
            let ownKeys = [];

            _.each(keysArr, (obj) => {
                if (parentValues[obj] == null || parentValues[obj] !== ownValues[obj]) {
                    ownKeys.push(obj);
                }
            });
            return ownKeys.length;
        }
    }

    constructor(props) {
        super(props);

        let forActualChart = true; //LL: false when with standard inheritance, on upper levels
        //LL: this.props.values  =>  this.props.options.widgetValues  this.props.options.widgetTypeName
        let props_values = this.getPropsValues();

        if (props_values == null) {
            forActualChart = false; //LL: when with standard inheritance, on upper levels
        }

        this.state = {
            counter: 0,
            forActualChart: forActualChart
        };
    }

    componentDidMount() {
        if (Array.isArray(this.props.value)) {
            if (this.props.value.length !== 0) alert(' --- componentDidMount: arr, len > 0');
            //this.props.value = {};
        }

        let N = 0;

        $.each(this.props.value, (key, obj) => {
            //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
            if (key !== 'isSet' && key !== 'removeAxis') {
                let name = obj.name;

                if (name.substr(0, 4) == 'AUX_') {
                    let n = parseInt(name.substr(4));

                    if (!isNaN(n) && n > N) {
                        N = n;
                    }
                }
            }
        });
        this.setState({
            counter: N
        });
    }

    componentWillReceiveProps(nextProps) {
        if (Array.isArray(nextProps.value)) {
            nextProps.value = {};
        }
    }

    handleOnValueChange(value) {
        if (typeof this.props.options.onChange === 'function') {
            // this.props.options.widgetValues - Chart props
            // value - AxisArray value object { AUX_1:  , AUX_2: }
            this.props.options.onChange(this.props.options.widgetValues, value, 'ChartAxisArrayField_inThemes');
        }

        //LL: standard:
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value); //LL: to ThemeField.tsx  getChangeHandler
        }
    }

    addPredefinedAxis = (selectedPredefinedAxis) => {
        //  axis.name, may be null or ''

        if (selectedPredefinedAxis == null || selectedPredefinedAxis === '') return;

        let themeFieldForAxisList = this.props.options.themeFieldForAxisList;
        let themeObj = this.props.themeObj;

        if (themeFieldForAxisList != null && themeObj != null) {
            let axisList = themeObj[themeFieldForAxisList];
            if (axisList != null && axisList.length > 0) {
                const axisObj = _.find(axisList, (obj) => {
                    return obj.name === selectedPredefinedAxis;
                });

                if (axisObj != null) {
                    //console.log('addPredefinedAxis FOUND axisObj.dataType = ' + axisObj.dataType);
                    //  name, inherited - to remove them;   dataType -> dataTypePredefined
                    let axisObjNew = $.extend(true, {}, axisObj);
                    delete axisObjNew.inherited;
                    delete axisObjNew.name;
                    delete axisObjNew.dataType;

                    axisObjNew.namePredefined = axisObj.name;
                    axisObjNew.dataTypePredefined = axisObj.dataType;

                    // position:  see in ChartAxisListField:
                    //    let a = ['bottom', 'top'];
                    //    let d = ['bottom/left', 'top/right'];
                    //  So, change for Value axis:
                    if (axisObjNew.position === 'top') axisObjNew.position = 'right';
                    else if (axisObjNew.position === 'bottom') axisObjNew.position = 'left';

                    if (axisObj.show != null) axisObjNew.visible = axisObj.show;
                    if (axisObj.showLabels != null) axisObjNew.labelsVisible = axisObj.showLabels;
                    if (axisObj.labelFormat != null) axisObjNew.labelsFormat = axisObj.labelFormat;
                    if (axisObj.labelCurrency != null) axisObjNew.labelsCurrency = axisObj.labelCurrency;
                    if (axisObj.customFormat != null) axisObjNew.customFormat = axisObj.customFormat;
                    if (axisObj.labelPrecision != null) axisObjNew.labelsPrecision = axisObj.labelPrecision;
                    if (axisObj.labelHasCustomFormat != null)
                        axisObjNew.labelsHasCustomFormat = axisObj.labelHasCustomFormat;
                    //delete axisObjNew.showLabels;
                    //delete axisObjNew.labelFormat;
                    //delete axisObjNew.labelCurrency;
                    //delete axisObjNew.customFormat;
                    //delete axisObjNew.labelPrecision;
                    //delete axisObjNew.labelHasCustomFormat;

                    this.addRow(axisObjNew);
                }
            }
        }
    };

    addRow = (obj) => {
        let counter = this.state.counter;

        counter++;
        this.setState({
            counter: counter
        });

        let name = 'AUX_' + counter.toString();
        obj.name = name;

        let value = _.clone(this.props.value);
        value[name] = obj;
        this.handleOnValueChange(value);
    };

    handleOnChangeRow = (obj, i) => {
        //LL:  this.props.value  is array, initially empty, so find by obj.name
        //LL:  maybe must be not array, but {}, key = obj.name ( = axis.name, = "AUX_1" )  ?  Yes !

        let name = obj.name;

        let value = _.clone(this.props.value);
        value[name] = obj;
        this.handleOnValueChange(value);
    };

    handleOnRemoveRow = (axisName: string) => {
        let forActualChart = this.state.forActualChart; // false - when with standard inheritance, on upper levels

        if (!forActualChart) {
            //LL: maybe try to analyze, is used or not ?
            //LL:  use our confirm dlg ?
            let result = confirm('Axis ' + axisName + ' is to be removed. \nBe sure that it is not used in Widgets.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        let value = _.clone(this.props.value);
        delete value[axisName];

        this.handleOnValueChange(value);
    };

    //LL: this.props.values  =>  this.props.options.widgetValues  this.props.options.widgetTypeName
    getPropsValues() {
        let result;

        if (this.props.options != null && this.props.options.widgetValues != null) {
            if (this.props.options.widgetTypeName === 'pdc-widget-chart') {
                result = this.props.options.widgetValues;
            }
        }

        return result;
    }

    render() {
        //LL: with standard inheritance, on upper levels. See ChartAxisField_inThemes
        let forActualChart = this.state.forActualChart; // false - when with standard inheritance, on upper levels
        //LL: this.props.values  =>  this.props.options.widgetValues  this.props.options.widgetTypeName
        const propsValues = this.getPropsValues();
        // --------------------------
        //LL: ownKeys - props with these keys will have glyphicon-remove
        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:
        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentValues_forObjects(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;
        //LL: this is new for object-fields:
        let keysArr = _.keys(ownValues); // _.keys({one: 1, two: 2, three: 3}); => ["one", "two", "three"]
        let ownKeys = [];

        _.each(keysArr, (obj) => {
            if (parentValues[obj] == null || parentValues[obj] !== ownValues[obj]) {
                ownKeys.push(obj);
            }
        });
        // --------------------------

        let arr = [];

        $.each(this.props.value, (key, obj) => {
            //LL: these keys are outdated functionality, not used anywhere. Was used when in Params, not in Themes
            if (key !== 'isSet' && key !== 'removeAxis') {
                arr.push(_.extend({}, obj));
            }
        });

        let rows = _.map(arr, (obj, i) => {
            //LL: ownKeys- props with these keys are not inherited
            let ownKey = isOwnKey(ownKeys, obj.name);

            //LL: for using appTheme.getThemeOwnAndParentValues_forObjects in internal ChartAxisField
            let parentObj = parentValues[obj.name] || {}; // may be null
            //  ownObj is just obj: value={obj}       also forActualChart, if false => values={props_values} is null

            //LL: Note about canRemove ==========================
            //     - On Widget Level: (forActualChart is true)
            //  if is used in DataQuery => canRemove = false, "remove" button is grayed
            //  if is not used in DataQuery =>
            //        own is defined or redefined (ownKey is true, isInherited is false)  =>  canRemove = true, ordinary "remove" button
            //        inherited is used (ownKey is false, isInherited is true)  =>  canRemove = false, "arrow-down" button
            //  ---------------------------------
            //     - On Upper Levels:
            //  canRemove always true ?
            //  No, depends on More-Upper Level inheritance => depends on ownKey: same as - when is not used in DataQuery
            //  Before removing show confirmation message, but do not check if is used actually in any Widget - done
            //  ---------------------------------
            //  What to do,
            //   if AuxAxis is removed on Upper Level and this AuxAxis is used in DataQuery and is not re-defined on Widget Level ?
            //  Error msg ?  Change AUX to Y ?
            //  ---------------------------------

            const isInherited = !ownKey;

            let useInheritedButton = false;
            let canRemove = true;

            if (forActualChart) {
                //LL: props_values is not null in this case
                let isUsedInDataQuery = ChartPropsManager.isUsed_SecondaryValueAxis_Multi(
                    propsValues.attrQueryMulti,
                    obj.name
                );

                if (isUsedInDataQuery) {
                    canRemove = false;
                } else {
                    if (isInherited) {
                        canRemove = false;
                        useInheritedButton = true;
                    }
                }
            } else {
                // on Upper Levels
                if (isInherited) {
                    canRemove = false;
                    useInheritedButton = true;
                }
            }

            return (
                <ChartAxisArrayFieldRow
                    key={i + '-' + obj.name}
                    i={i}
                    ownKey={ownKey}
                    parentObj={parentObj}
                    forActualChart={forActualChart}
                    isInherited={isInherited}
                    useInheritedButton={useInheritedButton}
                    canRemove={canRemove}
                    //empty={true}
                    value={obj}
                    values={propsValues}
                    options={this.props.options}
                    themeObj={this.props.themeObj}
                    themeFields_forDefaultColors={this.props.options.themeFields_forDefaultColors}
                    themeFieldForAxisList={this.props.options.themeFieldForAxisList}
                    //getFormatFrontArray_Numeric_Func={this.props.options.getFormatFrontArray_Numeric_Func}
                    //getFormatFrontArray_DateTime_Func={this.props.options.getFormatFrontArray_DateTime_Func}
                    //getFormatFrontArray_Date_Func={this.props.options.getFormatFrontArray_Date_Func}
                    //getFormatFrontArray_Time_Func={this.props.options.getFormatFrontArray_Time_Func}
                    //getFormatFrontArray_TimePart_Func={this.props.options.getFormatFrontArray_TimePart_Func}
                    //getFormatFrontArray_TimeIntervals_Int_Func={this.props.options.getFormatFrontArray_TimeIntervals_Int_Func}
                    //getFormatFrontArray_TimeIntervals_Real_Func={this.props.options.getFormatFrontArray_TimeIntervals_Real_Func}
                    getDataType_Func={ChartPropsManager.get_argumentAxis_DataType_withTimePart}
                    isAssignedSecondaryAxis_Func={ChartPropsManager.isAssignedSecondaryAxis}
                    is_fullStackedOnAxis_Func={ChartPropsManager.is_fullStackedOnAxis}
                    getModifiedValuesAndDisplay_Full_Func={
                        ChartPropsManager.getModifiedValuesAndDisplay_secondaryAxis_AxisType_Full
                    }
                    canAxisLabelPrecision_byLabelFormat_Func={ChartPropsManager.canAxisLabelPrecision_byLabelFormat}
                    hasAxis_Bubble_Func={ChartPropsManager.hasAxis_Bubble}
                    glob={this.props.glob}
                    onChange={this.handleOnChangeRow}
                    onRemove={this.handleOnRemoveRow}
                />
            );
        });

        return (
            <div className="chart-multi-axis-field">
                {rows}
                <ChartAxisArrayFieldRow
                    fictiv={true}
                    options={this.props.options}
                    themeObj={this.props.themeObj}
                    themeFieldForAxisList={this.props.options.themeFieldForAxisList}
                    glob={this.props.glob}
                    onAddRow={this.addRow}
                    onAddPredefinedAxis={this.addPredefinedAxis}
                />
            </div>
        );
    }
}
